import { CircleQuestionMark } from 'lucide-react';
import { DeckardIconWrapper } from './DeckardIcon';

export const HelpIcon = DeckardIconWrapper({ Icon: CircleQuestionMark });
